import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import UserCard from '../../Chat/UserCard/UserCard';
import MultiSelect from '../MultiSelect/MultiSelect';
import { userData } from '../../../assets/data/usersData';
import { Box, IconButton, TableFooter } from '@mui/material';
import { ArrowNext } from '../../../assets/icons/arrow-next';
import styles from "./Table.module.scss"
import SelectDropdown from '../SelectDropdown/SelectDropdown';
import { DeleteIcon } from '../../../assets/icons/delete-icon';
import Pagination from '../Pagination/Pagination';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function GenericTable({ columns, rows, forUsers = false, forChats = false }) {


    const [currentPage, setCurrentPage] = useState(1); // defining current page by default it is 1
    const [dataPerPage] = useState(10); // defining size of data per page
    // Get current list/page data
    const indexOfLastPost = currentPage * dataPerPage;
    const indexOfFirstPost = indexOfLastPost - dataPerPage;
    const currentUserList =
        rows && rows?.slice(indexOfFirstPost, indexOfLastPost);

    // Change page number
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    return (
        <TableContainer component={Paper} className={styles.root}>
            <Table size="small" aria-label="data table" >
                <TableHead>
                    <TableRow>
                        {columns?.map((column, index) =>
                            <TableCell className={styles.table_heading} style={{ paddingLeft: index == 0 ? "45px" : "" }}>{column}</TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows?.map((row) => {
                        // Fro admin chats list
                        if (forChats) return <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row" sx={{ width: "200px" }}>
                                <UserCard title={row?.chatInfo?.chatName} subTitle={`${row?.chatInfo?.no_users} users`} />
                            </TableCell>


                            <TableCell align="right">
                                <MultiSelect listData={userData?.filter(user => { return { name: user.name, id: user.id } })} />
                            </TableCell>
                            <TableCell align="right">
                                <IconButton>
                                    <Link to={'/admin/chat/' + row.id}>
                                        <ArrowNext />
                                    </Link>
                                </IconButton>
                            </TableCell>
                        </TableRow>

                        // for admin users list
                        if (forUsers) return <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row" sx={{ width: "200px" }}>
                                <UserCard title={row?.name} />
                            </TableCell>
                            <TableCell component="th" scope="row" className={styles.row_data}>
                                {row?.id}
                            </TableCell>

                            <TableCell align="right">
                                <SelectDropdown options={["admin", "user"]} />
                            </TableCell>
                            <TableCell align="right">
                                <IconButton>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    })}
                </TableBody>

            </Table>
            <Box style={{ width: '100%' }}>
                <Pagination
                    totalData={100}//{rows?.length}
                    dataPerPage={dataPerPage}
                    paginate={paginate}
                    currentPage={currentPage}
                />
            </Box>
        </TableContainer >
    );
}

